import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Typography,
  Grid,
  Chip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  OutlinedInput,
  Divider,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { useTheme } from "@emotion/react";
import { useStyles } from "../../../theme/style";
import { getUseCases, searchModels } from "../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  updateRapidInfraData,
  updateTotalCostData,
} from "../../../redux/slice/dataSlice";
// import { updateAIModelsData, updateSelectedAIModel, updateAIModelsJsonData } from "../../../redux/slice/dataSlice";
import { updateAIModelsJsonData } from "../../../redux/slice/dataSlice";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { getDevEnvironment, getTotalCost } from "../../../utils/utils";

// Priorities: prefer backend; fallback below is used only if backend omits them
const availablePriorities = [
  "Performance",
  "Speed & Resource Use",
  "Cost & Value",
  // "Ease of Use",
  "Reliability",
];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const usecaseMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 360,
    },
  },
};

function ChooseAIModel({ handleNext, handleBack, isRegistering }) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: routeRegisterId } = useParams();
  const isReadOnly = !isRegistering;
  let total_cost = useSelector((state) => state.data.rapidData?.total_cost);
  // total_cost = total_cost === "loading" ? "..." : "$ " + total_cost.toFixed(2);

  const selectedUsecases = useSelector(
    (state) => state.data.rapidData?.aiModelJson?.usecases
  );
  const priority1 = useSelector(
    (state) => state.data.rapidData?.aiModelJson?.priority_1
  );
  const priority2 = useSelector(
    (state) => state.data.rapidData?.aiModelJson?.priority_2
  );

  const priority3 = useSelector(
    (state) => state.data.rapidData?.aiModelJson?.priority_3
  );

  // Redux state
  const infraDataJson = useSelector((state) => state.data.rapidData?.infraJson);
  const [isLoadingUseCases, setIsLoadingUseCases] = useState(false);
  const [useCasesList, setUseCasesList] = useState([]);
  const [isLoadingModels, setIsLoadingModels] = useState(false);
  const modelsList = useSelector((state) => {
    const selectedCategory = state.data.rapidData?.infraJson.filter(
      (item) => item?.category_id === 2
    );
    const selectedCompnent = selectedCategory[0]?.components.filter(
      (item) => item?.component_id === 35
    );

    return selectedCompnent[0]?.properties;
  });
  const selectedModelsList = useSelector((state) => {
    const selectedCategory = state.data.rapidData?.infraJson.filter(
      (item) => item?.category_id === 2
    );
    const selectedCompnent = selectedCategory[0]?.components.filter(
      (item) => item?.component_id === 35
    );

    return selectedCompnent[0]?.value || [];
  });
  const [showMaxPopup, setShowMaxPopup] = useState(false);
  const [showMaxModelsPopup, setShowMaxModelsPopup] = useState(false);
  // const [isLoadingFromRedux, setIsLoadingFromRedux] = useState(true);
  const [useCasesLoaded, setUseCasesLoaded] = useState(false);

  const fetchUseCases = async () => {
    try {
      setIsLoadingUseCases(true);
      const resp = await getUseCases();
      const statusCode = resp?.data?.status?.statusCode;
      if (statusCode === 200) {
        const rawList = resp?.data?.data?.usecases;
        setUseCasesList(rawList || []);
        setUseCasesLoaded(true);
      } else {
        setUseCasesList([]);
        setUseCasesLoaded(true); // Still mark as loaded even if empty
        dispatch(
          updateAlertInfo({
            message: "Unable to fetch use cases list",
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error fetching use cases:", err);
      setUseCasesList([]);
      setUseCasesLoaded(true); // Still mark as loaded even on error
      dispatch(
        updateAlertInfo({
          message: "Internal Server Error",
          open: true,
          severity: "error",
        })
      );
    } finally {
      setIsLoadingUseCases(false);
    }
  };

  const handleUsecaseChange = (event) => {
    if (isReadOnly) return;
    const value = event.target.value;
    if (value.length > 3) {
      setShowMaxPopup(true);
      return;
    }

    if (value.length === 0) {
      dispatch(
        updateAIModelsJsonData({
          usecases: value,
          priority_1: "",
          priority_2: "",
          priority_3: "",
        })
      );
    } else {
      dispatch(
        updateAIModelsJsonData({
          usecases: value,
          priority_1: priority1,
          priority_2: priority2,
          priority_3: priority3,
        })
      );
    }
  };

  const handleModelSelection = (model) => {
    if (isReadOnly) return;

    const isModelExist = selectedModelsList.some(
      (item) =>
        item.property_id === model.property_id &&
        item.property_value === model.property_value
    );

    let modifiedList = [];
    if (isModelExist) {
      modifiedList = selectedModelsList.filter(
        (item) =>
          !(
            item.property_id === model.property_id &&
            item.property_value === model.property_value
          )
      );

      const updatedData = infraDataJson.map((category) => {
        if (category.category_id === 2) {
          return {
            ...category,
            components: category.components.map((component) => {
              if (component.component_id === 35) {
                return { ...component, value: modifiedList };
              }
              return component;
            }),
          };
        }
        return category;
      });
      dispatch(updateRapidInfraData(updatedData));
    } else if (selectedModelsList.length >= 4) {
      setShowMaxModelsPopup(true);
    } else {
      modifiedList = [...selectedModelsList, model];
      const updatedData = infraDataJson.map((category) => {
        if (category.category_id === 2) {
          return {
            ...category,
            components: category.components.map((component) => {
              if (component.component_id === 35) {
                return { ...component, value: modifiedList };
              }
              return component;
            }),
          };
        }
        return category;
      });
      dispatch(updateRapidInfraData(updatedData));
    }
  };

  const handleNextClick = () => {
    handleNext();
  };

  const searchAIModels = async () => {
    const priorities = [priority1, priority2, priority3].filter(Boolean);
    let modifiedModelList = [];
    try {
      setIsLoadingModels(true);
      const payload = {
        usecase: selectedUsecases,
        priority: priorities,
      };
      const resp = await searchModels({ payload });
      const statusCode = resp?.data?.status?.statusCode;
      if (statusCode === 200) {
        modifiedModelList = resp?.data?.data?.models?.map((item) => {
          return {
            cost:
              item?.cost_per_million_tokens !== null
                ? item?.cost_per_million_tokens
                : 0,
            property_id: item.OEM,
            property_value: item.model_name,
            score: item.ranking,
          };
        });
      }
    } catch (err) {
      console.error("Error searching models:", err);
      setIsLoadingModels(false);
      dispatch(
        updateAlertInfo({
          message: "Internal Server Error",
          open: true,
          severity: "error",
        })
      );
    }
    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === 2) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === 35) {
              return { ...component, properties: modifiedModelList, value: [] };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
    setIsLoadingModels(false);
  };

  // Fetch UseCases
  useEffect(() => {
    if (!isReadOnly) {
      fetchUseCases();
    } else {
      // In readonly mode, mark use cases as "loaded" so search logic doesn't wait
      setUseCasesLoaded(true);
    }
  }, []);

  // Fetch ChooseModel API
  useEffect(() => {
    if (!isReadOnly && useCasesLoaded) {
      const priorities = [priority1, priority2, priority3].filter(Boolean);

      if (selectedUsecases.length > 0 && priorities.length > 0) {
        searchAIModels();
      } else {
        const updatedData = infraDataJson.map((category) => {
          if (category.category_id === 2) {
            return {
              ...category,
              components: category.components.map((component) => {
                if (component.component_id === 35) {
                  return { ...component, properties: [], value: [] };
                }
                return component;
              }),
            };
          }
          return category;
        });
        dispatch(updateRapidInfraData(updatedData));
      }
    }
  }, [selectedUsecases, priority1, priority2, priority3, useCasesLoaded]);

  useEffect(() => {
    const enviromant = getDevEnvironment(infraDataJson);
    const cost = getTotalCost(
      infraDataJson,
      enviromant?.dev,
      enviromant?.uat,
      enviromant?.prod
    );
    dispatch(updateTotalCostData(cost));
  }, [selectedModelsList]);

  return (
    <>
      {/* Model Select content*/}
      <Box
        sx={{
          width: "100%",
          flex: 1,
          boxSizing: "border-box",
          maxHeight: "90%",
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{
              fontSize: theme.size[16],
              fontWeight: theme.fontWeight[500],
              marginTop: theme.size[24],
              color: theme.palette.primary.darkViolet,
              marginBottom: theme.size[16],
              px: 0,
            }}
          >
            Choose AI Model
          </Typography>
        </Box>
        <Box sx={{ width: "100%", boxSizing: "border-box", px: 0 }}>
          <Typography
            sx={{
              color: theme.palette.primary.darkViolet,
              fontWeight: 500,
              mb: 1,
              fontSize: 15,
            }}
          >
            Usecase Category
          </Typography>
          <FormControl
            fullWidth
            size="small"
            variant="outlined"
            sx={{ mb: 2 }}
            disabled={isReadOnly}
          >
            <Select
              multiple
              value={selectedUsecases}
              onChange={handleUsecaseChange}
              input={<OutlinedInput />}
              displayEmpty
              renderValue={(selected) =>
                isLoadingUseCases ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={16} />
                    <span style={{ color: "#aaa" }}>Loading use cases...</span>
                  </Box>
                ) : selected.length === 0 ? (
                  <span style={{ color: "#aaa" }}>Select Usecase Category</span>
                ) : (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {selected.map((value, index) => (
                      <Chip
                        key={index}
                        label={value}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                        }}
                        {...(!isReadOnly
                          ? {
                              onDelete: () => {
                                const next = selectedUsecases.filter(
                                  (u) => u !== value
                                );
                                if (next.length === 0) {
                                  dispatch(
                                    updateAIModelsJsonData({
                                      usecases: next,
                                      priority_1: "",
                                      priority_2: "",
                                      priority_3: "",
                                    })
                                  );
                                } else {
                                  dispatch(
                                    updateAIModelsJsonData({
                                      usecases: next,
                                      priority_1: priority1,
                                      priority_2: priority2,
                                      priority_3: priority3,
                                    })
                                  );
                                }
                              },
                            }
                          : {})}
                        color="default"
                        variant="outlined"
                        sx={(theme) => ({
                          borderRadius: 999,
                          fontWeight: 500,
                          fontSize: 13,
                          height: 28,
                          borderColor: theme.palette.primary.main,
                          color: theme.palette.primary.main,
                          backgroundColor: "transparent",
                          "& .MuiChip-deleteIcon": {
                            color: theme.palette.primary.main,
                          },
                        })}
                      />
                    ))}
                  </Box>
                )
              }
              sx={{ background: "transparent", borderRadius: 2 }}
              MenuProps={usecaseMenuProps}
            >
              {isLoadingUseCases ? (
                <MenuItem disabled>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress size={16} />
                    <span>Loading use cases...</span>
                  </Box>
                </MenuItem>
              ) : useCasesList.length > 0 ? (
                useCasesList.map((usecase, index) => (
                  <MenuItem key={index} value={usecase}>
                    <Checkbox
                      checked={selectedUsecases.indexOf(usecase) > -1}
                      color="primary"
                    />
                    {usecase}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  <span style={{ color: "#aaa" }}>No use cases available</span>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ width: "100%", boxSizing: "border-box", px: 0 }}>
          <Grid container spacing={2} sx={{ mb: 1, width: "100%" }}>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: theme.palette.primary.darkViolet,
                  fontWeight: 500,
                  mb: 1,
                  fontSize: 15,
                }}
              >
                Priority 1
              </Typography>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                disabled={isReadOnly || selectedUsecases.length === 0}
                sx={(theme) => ({
                  background:
                    selectedUsecases.length === 0 ? "#f5f5f5" : "transparent",
                  borderRadius: 2,
                  border: `1px solid ${
                    selectedUsecases.length === 0
                      ? "#e0e0e0"
                      : theme.palette.primary.main
                  }`,
                  ".MuiInputBase-root": {
                    background:
                      selectedUsecases.length === 0 ? "#f5f5f5" : "transparent",
                    borderRadius: 2,
                    border: "none",
                  },
                  ".MuiSelect-select": {
                    color:
                      selectedUsecases.length === 0
                        ? "#aaa"
                        : theme.palette.primary.main,
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                })}
              >
                <Select
                  value={priority1}
                  onChange={(e) => {
                    if (!isReadOnly) {
                      dispatch(
                        updateAIModelsJsonData({
                          usecases: selectedUsecases,
                          priority_1: e.target.value,
                          priority_2: priority2,
                          priority_3: priority3,
                        })
                      );
                    }
                  }}
                  sx={{
                    background: "transparent",
                    borderRadius: 2,
                    border: `1px solid ${theme.palette.primary.main}`,
                  }}
                  displayEmpty
                  renderValue={(selected) =>
                    selected ? (
                      selected
                    ) : (
                      <span style={{ color: "#aaa" }}>Select Priority 1</span>
                    )
                  }
                >
                  {availablePriorities.map((p) => (
                    <MenuItem
                      key={p}
                      value={p}
                      disabled={priority2 === p || priority3 === p}
                      sx={{
                        color:
                          priority2 === p || priority3 === p
                            ? "#aaa"
                            : theme.palette.primary.main,
                        fontWeight:
                          priority2 === p || priority3 === p ? 400 : 500,
                        opacity: priority2 === p || priority3 === p ? 0.5 : 1,
                        "&:hover": {
                          backgroundColor:
                            priority2 === p || priority3 === p
                              ? "transparent"
                              : theme.palette.action.hover,
                        },
                      }}
                    >
                      {p}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: theme.palette.primary.darkViolet,
                  fontWeight: 500,
                  mb: 1,
                  fontSize: 15,
                }}
              >
                Priority 2
              </Typography>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                disabled={
                  isReadOnly || selectedUsecases.length === 0 || !priority1
                }
                sx={(theme) => ({
                  background:
                    selectedUsecases.length === 0 || !priority1
                      ? "#f5f5f5"
                      : "transparent",
                  borderRadius: 2,
                  border: `1px solid ${
                    selectedUsecases.length === 0 || !priority1
                      ? "#e0e0e0"
                      : theme.palette.primary.main
                  }`,
                  ".MuiInputBase-root": {
                    background:
                      selectedUsecases.length === 0 || !priority1
                        ? "#f5f5f5"
                        : "transparent",
                    borderRadius: 2,
                    border: "none",
                  },
                  ".MuiSelect-select": {
                    color:
                      selectedUsecases.length === 0 || !priority1
                        ? "#aaa"
                        : theme.palette.primary.main,
                  },
                  ".MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                })}
              >
                <Select
                  value={priority2}
                  onChange={(e) => {
                    if (!isReadOnly) {
                      dispatch(
                        updateAIModelsJsonData({
                          usecases: selectedUsecases,
                          priority_1: priority1,
                          priority_2: e.target.value,
                          priority_3: priority3,
                        })
                      );
                    }
                  }}
                  sx={{
                    background: "transparent",
                    borderRadius: 2,
                    border: `1px solid ${theme.palette.primary.main}`,
                  }}
                  displayEmpty
                  renderValue={(selected) =>
                    selected ? (
                      selected
                    ) : (
                      <span style={{ color: "#aaa" }}>Select Priority 2</span>
                    )
                  }
                >
                  {availablePriorities.map((p) => (
                    <MenuItem
                      key={p}
                      value={p}
                      disabled={priority1 === p || priority3 === p}
                      sx={{
                        color:
                          priority1 === p || priority3 === p
                            ? "#aaa"
                            : theme.palette.primary.main,
                        fontWeight:
                          priority1 === p || priority3 === p ? 400 : 500,
                        opacity: priority1 === p || priority3 === p ? 0.5 : 1,
                        "&:hover": {
                          backgroundColor:
                            priority1 === p || priority3 === p
                              ? "transparent"
                              : theme.palette.action.hover,
                        },
                      }}
                    >
                      {p}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        {/* AI Models Table */}
        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <Typography
              sx={{
                color: theme.palette.primary.darkViolet,
                fontWeight: 500,
                fontSize: 15,
              }}
            >
              Recommended Available Models
            </Typography>
            {isLoadingModels && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} />
                <Typography
                  sx={{ fontSize: 12, color: theme.palette.grey[600] }}
                >
                  Searching...
                </Typography>
              </Box>
            )}
            <Typography
              sx={{ fontSize: 12, color: theme.palette.grey[600], ml: "auto" }}
            >
              Selected: {selectedModelsList.length}/4
            </Typography>
          </Box>
          <TableContainer
            sx={{
              border: `1px solid ${theme.palette.grey[200]}`,
              borderRadius: 0,
              background: "transparent",
              maxHeight: 300,
              width: "100%",
            }}
          >
            <Table stickyHeader sx={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      color: theme.palette.primary.darkViolet,
                      fontWeight: 600,
                      background: "#f4f6fa",
                      borderRadius: 0,
                    }}
                  >
                    {" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme.palette.primary.darkViolet,
                      fontWeight: 600,
                      background: "#f4f6fa",
                      borderRadius: 0,
                    }}
                  >
                    OEM
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme.palette.primary.darkViolet,
                      fontWeight: 600,
                      background: "#f4f6fa",
                      borderRadius: 0,
                    }}
                  >
                    Model
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme.palette.primary.darkViolet,
                      fontWeight: 600,
                      background: "#f4f6fa",
                      borderRadius: 0,
                    }}
                  >
                    Cost for 1 Million Tokens ($)
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme.palette.primary.darkViolet,
                      fontWeight: 600,
                      background: "#f4f6fa",
                      borderRadius: 0,
                    }}
                  >
                    Score
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoadingModels ? (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: "center", py: 4 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 2,
                        }}
                      >
                        <CircularProgress size={20} />
                        <Typography>Loading AI models...</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : modelsList.length > 0 ? (
                  modelsList.map((model, index) => (
                    <TableRow
                      key={index}
                      hover
                      selected={selectedModelsList.some(
                        (selectedModel) =>
                          selectedModel.property_id === model.property_id &&
                          selectedModel.property_value === model.property_value
                      )}
                      sx={{
                        height: theme.size[50],
                        cursor: isReadOnly ? "default" : "pointer",
                        "&.Mui-selected": {
                          background: theme.palette.action.selected,
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: theme.size[16], py: 0.5 }}>
                        <Checkbox
                          color="primary"
                          checked={
                            // isReadOnly
                            //   ? true
                            //   :

                            selectedModelsList.some(
                              (selectedModel) =>
                                selectedModel.property_value ===
                                model.property_value
                            )
                          }
                          onChange={() => handleModelSelection(model)}
                          disabled={
                            isReadOnly
                            // ||
                            // (selectedModelsList.length >= 4 &&
                            //   !selectedModelsList.some(
                            //     (selectedModel) =>
                            //       selectedModel.property_id === model.property_id &&
                            //       selectedModel.property_value === model.property_value
                            //   ))
                          }
                          sx={{ p: 0.5 }}
                        />
                      </TableCell>
                      <TableCell sx={{ fontSize: theme.size[16], py: 0.5 }}>
                        {model.property_id}
                      </TableCell>
                      <TableCell sx={{ fontSize: theme.size[16], py: 0.5 }}>
                        {model.property_value}
                      </TableCell>
                      <TableCell sx={{ fontSize: theme.size[16], py: 0.5 }}>
                        {model.cost ? model.cost : 0}
                      </TableCell>
                      <TableCell sx={{ fontSize: theme.size[16], py: 0.5 }}>
                        {model.score && typeof model.score === 'object' ? (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {Object.entries(model.score).map(([key, value]) => (
                              <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontSize: theme.size[12], color: theme.palette.grey[600] }}>
                                  {key}:
                                </Typography>
                                <Typography sx={{ fontSize: theme.size[12], fontWeight: 500, color: theme.palette.primary.main }}>
                                  {value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          model.score || 0
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: "center", py: 4 }}>
                      <Typography>
                        {isReadOnly
                          ? "No models available"
                          : selectedUsecases.length === 0 || !priority1
                          ? "Select use cases and priorities to see available models"
                          : "No models found for the selected criteria"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      {/* Popup for max 3 usecases */}
      <Dialog open={showMaxPopup} onClose={() => setShowMaxPopup(false)}>
        <DialogTitle>Limit Exceeded</DialogTitle>
        <DialogContent>
          <Typography>You can't select more than 3 usecases.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowMaxPopup(false)}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Popup for max 4 models */}
      <Dialog
        open={showMaxModelsPopup}
        onClose={() => setShowMaxModelsPopup(false)}
      >
        <DialogTitle>Model Selection Limit</DialogTitle>
        <DialogContent>
          <Typography>
            You can select a maximum of 4 AI models. Please deselect a model
            first to add a new one.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowMaxModelsPopup(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      {/* Footer: full width of main content, not centered, not maxWidth, not overlapping sidebar, buttons at edges, no horizontal scroll */}
      {isRegistering && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            position: "absolute",
            width: "100%",
            bottom: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div style={{ display: "flex" }}>
              <Button
                disableRipple
                className={classes.outlinedButton}
                onClick={handleBack}
                style={{ fontWeight: theme.fontWeight[500] }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WestIcon
                    sx={{
                      fontSize: theme.size[18],
                      marginRight: theme.size[4],
                    }}
                  />
                  <span>Back</span>
                </div>
              </Button>
            </div>
            <div
              style={{
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
                paddingTop: theme.size[4],
              }}
            >
              Back to Accelerator Libraries
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Button
              disableRipple
              className={classes.filledButton}
              onClick={handleNextClick}
              disabled={selectedModelsList.length === 0}
              style={{ fontWeight: theme.fontWeight[500] }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>Next</span>
                <EastIcon
                  sx={{ fontSize: theme.size[18], marginLeft: theme.size[4] }}
                />
              </div>
            </Button>
            <div
              style={{
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
                paddingTop: theme.size[4],
                textAlign: "right",
              }}
            >
              Total Cost
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ChooseAIModel;
